
import { SideNavButton } from './SideNavButton';

export const ModuleButton = ({ menu, onClick, setActiveSidenavMenu, isActive }) => {
  const label = menu.shortName ?? menu.displayName;
  return (
    <SideNavButton
      onClick={onClick} 
      icon={menu.icon} size="2x" 
      onMouseOver={() => setActiveSidenavMenu(menu)}
      label={label}
      isActive={isActive}
    />
  );
};
